import { css, keyframes } from 'styled-components';
import { theme } from 'styles/theme';

const shimmerAnimation = keyframes`
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
`;

const shimmer = css`
  background: linear-gradient(
    90deg,
    ${theme.colors.lightGrey} 25%,
    ${theme.colors.surfaceElevated} 50%,
    ${theme.colors.lightGrey} 75%
  );
  background-size: 800px 100%;
  animation: ${shimmerAnimation} 1.4s ease-in-out infinite;
`;

export { shimmer };
